import type { FaireProductEntity } from "../../entity_types/product";

export const p_pmqnsgzxk8: FaireProductEntity = {
  token: "p_pmqnsgzxk8",
  type: "product",
  name: "Stretch White Puka Shell Bracelet - PC",
  brandName: "Natalia",
  imageUrl:
    "https://cdn.faire.com/fastly/4107e9b52918b28120be9d91dd81fcdc5a758fc3cd8367adb8e48dd23b447357.jpeg",
  priceDollars: 1.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/84e2f4b0b93011146882b0bb8c87dfc6154fcf726e0b76119462e6a6923aabd0.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
